
import {
  populateImagesInSection,
  rewriteContentInSection
} from "@/lib/singularity/sections";
import { aiJobController } from "@/futurelayer/ai-job-manager/ai-jobs";
import { TreeNode } from "@/types/tree";
import { documentStore } from "@/store/store";
import Vue from "vue";
import { Component } from "vue-property-decorator";

@Component({
  components: {}
})
export default class SectionWriter extends Vue {
  sectionId: TreeNode["id"] = -1;

  async writeSection() {
    aiJobController.addJob(
      async abortController => {
        await rewriteContentInSection(this.sectionId, abortController);
      },
      {
        jobType: 'section_rewrite',
        documentId: documentStore.document.documentMeta.id,
        elementId: this.sectionId,
        description: `Section rewrite triggered manually from SectionWriter for section ${this.sectionId}`,
        priority: 'critical',
        snapshotLabel: 'Write Section with AI'
      }
    );
  }

  async populateImages() {
    aiJobController.addJob(
      async abortController => {
        await populateImagesInSection(this.sectionId, abortController);
      },
      {
        jobType: 'section_image_replacement',
        documentId: documentStore.document.documentMeta.id,
        elementId: this.sectionId,
        description: `Image population triggered manually from SectionWriter for section ${this.sectionId}`,
        priority: 'high',
        snapshotLabel: 'Populate Images in Section with AI'
      }
    );
  }
}
